
export const padding = {
  name: 'padding'
}

export const paddingTop = {
  name: 'padding-top'
}

export const paddingRight = {
  name: 'padding-right'
}

export const paddingBottom = {
  name: 'padding-bottom'
}

export const paddingLeft = {
  name: 'padding-left'
}
